export const HAKLAI_TAB_LABELS = Object.freeze({
  defaultDescription: "תיאור עסקה"
});
